import * as React from 'react';
import { createHashRouter, RouterProvider, Navigate } from 'react-router-dom';
import GuardRoute from './components/guardRoute';
import { AuthContextProvider } from './context/auth';
import { ThemeContextProvider } from './context/theme';
import { GlobalsContextProvider } from './context/globals';
import { LoadingModalContextProvider } from './components/modal/loading';
import { AlertModalContextProvider } from './components/modal/alert';
import { SnackbarProvider } from 'notistack';

import Login from './pages/login';
import Dashboard from './pages/dashboard';
import ReestablecerClave from './pages/reestablecer-clave';
import Usuario from './pages/usuario';
import EditarUsuario from './pages/usuario/editar';
import Area from './pages/area';
import EditarArea from './pages/area/editar';
import Personal from './pages/personal';
import EditarPersonal from './pages/personal/editar';
import DetallePersonal from './pages/personal/detalle';
import VerificarCredencial from './pages/verificacion';
import ImprimirCredencial from './pages/credencial/imprimir';

const router = createHashRouter([
	{ path: "/login", element: <GuardRoute type="public" path="/login" component={<Login />} /> },
	{ path: "/login/:token/:window", element: <GuardRoute type="public" path="/login/:token/:window" component={<Login />} /> },
	{ path: "/reestablecer-clave/:token", element: <GuardRoute type="public" path="/reestablecer-clave/:token" component={<ReestablecerClave />} /> },
	{ path: "/dashboard", element: <GuardRoute type="private" path="/dashboard" component={<Dashboard />} /> },
	{ path: "/usuario/nuevo", element: <GuardRoute type="private" path="/usuario/nuevo" component={<EditarUsuario />} /> },
	{ path: "/usuario/editar", element: <GuardRoute type="private" path="/usuario/editar" component={<EditarUsuario />} /> },
	{ path: "/usuario", element: <GuardRoute type="private" path="/usuario" component={<Usuario />} /> },
	{ path: "/area/nuevo", element: <GuardRoute type="private" path="/area/nuevo" component={<EditarArea />} /> },
	{ path: "/area/editar", element: <GuardRoute type="private" path="/area/editar" component={<EditarArea />} /> },
	{ path: "/area", element: <GuardRoute type="private" path="/area" component={<Area />} /> },
	{ path: "/personal/nuevo", element: <GuardRoute type="private" path="/personal/nuevo" component={<EditarPersonal />} /> },
	{ path: "/personal/editar", element: <GuardRoute type="private" path="/personal/editar" component={<EditarPersonal />} /> },
	{ path: "/personal/detalle", element: <GuardRoute type="private" path="/personal/detalle" component={<DetallePersonal />} /> },
	{ path: "/personal", element: <GuardRoute type="private" path="/personal" component={<Personal />} /> },
	{ path: "/v/:codigoPublico/:token", element: <GuardRoute type="global" path="/v/:codigoPublico/:token" component={<VerificarCredencial />} /> },
	{ path: "/credencial/imprimir/:codigoPublico/:token", element: <GuardRoute type="global" path="/credencial/imprimir/:codigoPublico/:token" component={<ImprimirCredencial />} /> },
	{ path: "/", element: <Navigate to="/login" replace /> },
]);

export default function AppRoot() {
	return (
		<AuthContextProvider>
			<GlobalsContextProvider>
				<ThemeContextProvider>
					<SnackbarProvider maxSnack={3} anchorOrigin={{ horizontal: "center", vertical: "bottom" }} autoHideDuration={6000}>
						<LoadingModalContextProvider>
							<AlertModalContextProvider>
								<InnerApp />
							</AlertModalContextProvider>
						</LoadingModalContextProvider>
					</SnackbarProvider>
				</ThemeContextProvider>
			</GlobalsContextProvider>
		</AuthContextProvider>
	);
}

function InnerApp() {
	React.useEffect(() => {
		const el = document.getElementById('initial-splash');
		const hide = () => {
			if (el?.parentNode) {
				try {
					el.parentNode.removeChild(el);
				} catch (_) {}
			}
		};
		// Opción 1: ocultar tras el primer paint de la app para evitar parpadeo
		requestAnimationFrame(() => requestAnimationFrame(hide));
	}, []);
	return <RouterProvider router={router} />;
}
